import Yup from '~/util/yup';
import { getScheduleDashboardOptions, resolveEvvExceptionOptions, type SearchEvvExceptionViewModel } from '@generated';
import { FormModal } from '~/shared/forms/FormModal';
import { getSearchQueryKey } from '~/util/http/useSearch';
import { TextAreaFormField } from '~/shared/forms/controls/fields/text-fields/TextAreaFormField';
import { CheckboxFormField } from '~/shared/forms/controls/fields/CheckboxFormField';

const validationSchema = Yup.object().shape({
	dispute: Yup.bool().label('Dispute'),
	notes: Yup.string()
		.label('Notes')
		.nullable()
		.when('dispute', {
			is: true,
			then: schema => schema.required()
		})
});

export function ReviewEvvExceptionFormModal({ exception, closeModal }: { exception: SearchEvvExceptionViewModel; closeModal: () => void }) {
	return (
		<FormModal
			title="Review EVV Exception"
			initialValues={{
				evvExceptionId: exception.id,
				dispute: false,
				notes: null
			}}
			saveMutation={{
				...resolveEvvExceptionOptions,
				invalidateQueryKeys: [getScheduleDashboardOptions().queryKey, getSearchQueryKey('evv-exception')]
			}}
			validationSchema={validationSchema}
			onSuccess={closeModal}
			closeModal={closeModal}
		>
			<div className="grid grid-cols-1 gap-4">
				<CheckboxFormField name="dispute" hideLabel />
				<TextAreaFormField name="notes" />
			</div>
		</FormModal>
	);
}
